"use strict";

import React from "react";
import Head from "next/head";
import { I18nextProvider } from "react-i18next";

import { startI18n } from "../src/helpers/i18n";
import MyHead from "../src/components/MyHead";
import Footer from "../src/components/Footer";

export default class Error extends React.Component {
  constructor(props) {
    super(props);
    this.i18n = startI18n(props.translations, props.locale);
  }

  render() {
    const { locale } = this.props;

    return (
      <I18nextProvider i18n={this.i18n}>
        <div>
          <MyHead locale={locale} />
          <Head>
            <title>{this.i18n.t("UNSUPPORTED_BROWSER")}</title>
          </Head>

          <section className="container" id="errorPage">
            <div className="col-md-12">
              <img
                src="/static/image/Icona+Naming_NeerU_Blue.svg"
                alt=""
                className="u-center-horizontal"
              />
              <h1 className="text-center u-bold">
                {this.i18n.t("UNSUPPORTED_BROWSER")}
              </h1>
              <div
                className="text-center errorPage__h1--color-black"
                dangerouslySetInnerHTML={{
                  __html: this.i18n.t("UNSUPPORTED_BROWSER_MESSAGE"),
                }}
              />
            </div>
          </section>
          <Footer fullWidth />
        </div>
      </I18nextProvider>
    );
  }
}



// WEBPACK FOOTER //
// pages/unsupportedBrowser.js